import { FormDataWithExtras, PreviewOptions } from '../extensions';

import { StepCollection } from './QuestionnaireResults/schema';
import { TreePropsViewer } from '../../components/TreePropsViewer';
import { getQuestionsByCategory } from './utils/question-grouping';

export interface GroupedFieldsProps {
  formData: FormDataWithExtras;
  steps: StepCollection;
  options: PreviewOptions;
}

export function GroupedQuestions(props: GroupedFieldsProps) {
  const { formData, steps, options } = props;
  const { mandatory } = options;
  const groups = getQuestionsByCategory(options, steps, formData);

  return <TreePropsViewer groups={groups} mandatory={mandatory} />;
}
